import React from 'react';
import { SvgIcon, Badge } from 'seduo-ui';
const Example = () => (<section className="mb-9 mb-lg-0 shadow-uniform card">
        <div className="card-body">
            <div>
                <div className="mb-7">
                    <h2>
                        <strong itemProp="offers" itemScope={true} itemType="http://schema.org/Offer">
                            <meta itemProp="price" content="1790"/>
                            <meta itemProp="priceCurrency" content="CZK"/>
                            Cena: 1&nbsp;790&nbsp;Kč
                        </strong>
                        &nbsp;
                        <span className="text-nowrap">s DPH</span>
                    </h2>
                </div>
                <div className="row mb-5">
                    <div className="col-7 col-md-3 col-lg-7">Počet lekcí:</div>
                    <div className="col-5 col-md-9 col-lg-5">
                        <strong>11</strong>
                    </div>
                </div>
                <div className="row mb-7">
                    <div className="col-7 col-md-3 col-lg-7">Celková délka videí:</div>
                    <div className="col-5 col-md-9 col-lg-5">
                        <strong>43 min</strong>
                    </div>
                </div>
                <p>Certifikát absolventa, Neomezený přístup</p>
            </div>
            <div className="mb-7">
                <a href="#" className="btn btn-primary btn-large btn-block">
                    <span className="mr-5">
                        <SvgIcon kind="BoxArrowIn" className="icon"/>
                    </span>
                    Přidat do plánu
                </a>
            </div>
            <a href="#" className="btn btn-outline-primary btn-large btn-block">
                <span className="mr-5">
                    <SvgIcon kind="Play" className="icon"/>
                </span>
                Spustit kurz
            </a>
        </div>
        <div className="card-gift">
            <div className="card-gift-header">
                <Badge color="light" pill className="mx-auto">
                    Dárek zdarma
                </Badge>
            </div>
            <div className="row no-gutters">
                <div className="col-12 col-md-3 mt-3">
                    <img width="50" height="50" src="https://dummyimage.com/50x50/9fa4a8/fff.png" alt="Gift image cap"/>
                </div>
                <div className="col-12 col-md-9 small text-muted">
                    Při koupi tohoto kurzu jako dárek získáte knihu Konec Prokrastinace zdarma.{' '}
                    <a href="#">Jak dárek získám?</a>
                </div>
            </div>
        </div>
        <div className="card-footer small text-muted">
            Pro získání dárku nemusíte nic dělat. Knihu vám zašleme na vaší fakturační adresu (kterou nemáme - poznámka
            přepisovatele). Pokud chcete dárek zaslat jinam, stačí to uvést do (neexistující - poznámka přepisovatele)
            poznámky k objednávce.
        </div>
    </section>);
export default Example;
